export const BOLETO_DELINQUENCY_TYPES_ENUM = {
  PROTEST: 'PROTEST',
  NEGATIVATION: 'NEGATIVATION',
} as const;

export type BoletoDelinquencyTypesEnum =
  (typeof BOLETO_DELINQUENCY_TYPES_ENUM)[keyof typeof BOLETO_DELINQUENCY_TYPES_ENUM];
